import 'vuetify/src/stylus/app.styl';
import {
	Vuetify,
	VAlert,
	VApp,
	VAutocomplete,
	VBtn,
	VBtnToggle,
	VCard,
	VCheckbox,
	VChip,
	VDataIterator,
	VDatePicker,
	VDialog,
	VDivider,
	VForm,
	VGrid,
	VIcon,
	VList,
	VMenu,
	VNavigationDrawer,
	VRadioGroup,
	VSelect,
	VSlider,
	VSnackbar,
	VSubheader,
	VTextField,
	VTimePicker,
	VToolbar,
	VTooltip,
	transitions,
	VExpansionPanel,
	VDataTable,
	VProgressLinear,
	VTabs,
	VTextarea,
	VStepper,
	VSwitch,
	VTreeview,
	VPagination,
} from 'vuetify';

export default function (Vue) {
	Vue.use(
		Vuetify,
		{
			components: {
				VAlert,
				VApp,
				VAutocomplete,
				VBtn,
				VBtnToggle,
				VCheckbox,
				VChip,
				VCard,
				VDataIterator,
				VDatePicker,
				VDialog,
				VDivider,
				VForm,
				VGrid,
				VIcon,
				VList,
				VMenu,
				VNavigationDrawer,
				VRadioGroup,
				VSelect,
				VSlider,
				VSnackbar,
				VSubheader,
				VTextField,
				VTimePicker,
				VToolbar,
				VTooltip,
				transitions,
				VExpansionPanel,
				VDataTable,
				VProgressLinear,
				VTabs,
				VTextarea,
				VStepper,
				VSwitch,
				VTreeview,
				VPagination,
			},
			theme: {
				primary: '#E0E5E8',
				secondary: '#006edb',
				accent: '#005CAF',
				error: '#f42b17',
				info: '#2DB6F5',
				success: '#00ca9d',
				warning: '#FFB74C',
				pink: '#fe6b7d',
				grey: '#e6eef1',
				cyan: '#00add4',
				white: '#ffffff',
				blue: '#006edb',
				red: '#ff0000',
			},
		},
	);
}



// WEBPACK FOOTER //
// ./src/vuetify.js